<template>
    <generic-page>
        <back-to-dashboard />

        <h5 class="mb-3 mt-2">{{ $t("Reports") }}</h5>

        <b-list-group>
            <b-list-group-item
                v-for="report in reports"
                :key="report.key"
                :to="report.to"
                class="d-flex align-items-center"
                action
            >
                <div class="mr-3">
                    <font-awesome-icon
                        class="branded"
                        :icon="report.icon"
                        size="lg"
                    />
                </div>
                <div class="flex-grow-1">
                    <div class="font-weight-bold">{{ $t(report.title) }}</div>
                    <div class="small text-muted">
                        {{ $t(report.description) }}
                    </div>
                </div>
                <font-awesome-icon
                    icon="fa-light fa-chevron-right"
                    class="text-muted"
                />
            </b-list-group-item>
        </b-list-group>
    </generic-page>
</template>

<script>
import BackToDashboard from "@/components/utility/BackToDashboard";

export default {
    data() {
        return {
            // Hardcoded — backend does not enumerate reports.
            // Add new entries here when introducing a new report.
            reports: [
                {
                    key: "sales",
                    title: "Sales report",
                    description:
                        "Monthly earnings, signups, and new buyers.",
                    to: "/affiliate/reports/sales",
                    icon: "fa-duotone fa-chart-line",
                },
                {
                    key: "landing",
                    title: "Landing pages report",
                    description:
                        "Total signups, buyers, and earnings by landing page.",
                    to: "/affiliate/reports/landing",
                    icon: "fa-duotone fa-flag",
                },
            ],
        };
    },
    components: {
        BackToDashboard,
    },
};
</script>
